import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

// Import configs and util modules
import { FormattedMessage } from '../../../util/reactIntl';
import { Button, Form, H4 } from '../../../components';

import doodle from './unboxing-doodle.svg';
// Import modules from this directory
import css from './InfoForm.module.css';

/**
 * The InfoForm component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.formId] - The form id
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {boolean} [props.disabled] - Whether the form is disabled
 * @param {boolean} [props.ready] - Whether the form is ready
 * @param {Function} props.onSubmit - The submit function
 * @param {boolean} [props.invalid] - Whether the form is invalid
 * @param {boolean} [props.pristine] - Whether the form is pristine
 * @returns {JSX.Element}
 */
export const InfoForm = props => (
  <FinalForm
    mutators={{ ...arrayMutators }}
    {...props}
    render={formRenderProps => {
      const {
        formId = 'InfoForm',
        form: formApi,
        className,
        rootClassName,
        disabled,
        ready,
        handleSubmit,
        invalid,
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = ready;
      const submitDisabled = invalid || disabled;

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          <img className={css.rootForImage} alt="doodle" src={doodle} />
          <H4 className={css.title}>
            <FormattedMessage id="PackagesModal.InfoForm.title" />
          </H4>
          <p className={css.description}>
            <FormattedMessage id="PackagesModal.InfoForm.description" />
          </p>
          <Button
            className={css.submitButton}
            type="submit"
            disabled={submitDisabled}
            ready={submitReady}
          >
            <FormattedMessage id="PackagesModal.InfoForm.saveActionMsg" />
          </Button>
        </Form>
      );
    }}
  />
);

export default InfoForm;
